export const openInNewTab = (url) => {
  let win = window.open(url, '_blank');
  console.log('opening new tab -------------------------------------------------------');
  if (win) {
    win.location;
  } else {
    window.location.href = url;
  }
};
